import { fetchForm, updateForm } from '../../../apis';
import { generateForm } from '../../form/Form';
var staticParts = ['createdAt', 'createdBy', 'handle', 'submittedAt', 'submittedBy', 'updatedAt', 'updatedBy'];

var getFields = function getFields(form) {
  return form.get('fields');
};

var getIndexDefinition = function getIndexDefinition(form, indexName) {
  return form.get('indexDefinitions').find(function (indexDefinition) {
    return indexDefinition.get('name') === indexName;
  });
};

var dataSources = function dataSources(_ref) {
  var formSlug = _ref.formSlug,
      indexName = _ref.indexName;
  return {
    form: {
      fn: fetchForm,
      params: [{
        datastore: true,
        kappSlug: null,
        formSlug: formSlug,
        include: 'fields,indexDefinitions'
      }],
      transform: function transform(result) {
        return result.form;
      }
    },
    fields: {
      fn: getFields,
      params: function params(_ref2) {
        var form = _ref2.form;
        return form && [form];
      }
    },
    indexDefinition: {
      fn: getIndexDefinition,
      params: function params(_ref3) {
        var form = _ref3.form;
        return form && indexName && [form, indexName];
      }
    }
  };
};

var handleSubmit = function handleSubmit(_ref4) {
  var formSlug = _ref4.formSlug,
      indexName = _ref4.indexName;
  return function (values, _ref5) {
    var form = _ref5.form;
    return updateForm({
      datastore: true,
      kappSlug: null,
      formSlug: formSlug,
      form: {
        indexDefinitions: indexName ? form.get('indexDefinitions').map(function (indexDefinition) {
          return indexDefinition.get('name') === indexName ? values : indexDefinition;
        }).toJS() : form.get('indexDefinitions').push(values).toJS()
      }
    }).then(function (_ref6) {
      var form = _ref6.form,
          error = _ref6.error;

      if (error) {
        throw error.statusCode === 400 && error.message || 'There was an error saving the index definition';
      }

      return form;
    });
  };
};

var fields = function fields(_ref7) {
  var formSlug = _ref7.formSlug,
      indexName = _ref7.indexName;
  return function (_ref8) {
    var indexDefinition = _ref8.indexDefinition;
    return (!indexName || indexDefinition) && [{
      name: 'parts',
      label: 'Parts',
      type: 'select-multi',
      required: true,
      options: function options(_ref9) {
        var fields = _ref9.fields;
        return fields ? fields.map(function (field) {
          return "values[".concat(field.get('name'), "]");
        }).sort().concat(staticParts).map(function (name) {
          return {
            label: name,
            value: name
          };
        }).toArray() : [];
      },
      initialValue: indexDefinition ? indexDefinition.get('parts') : []
    }, {
      name: 'unique',
      label: 'Unique',
      type: 'checkbox',
      initialValue: indexDefinition ? indexDefinition.get('unique') : false
    }];
  };
};

export var IndexDefinitionForm = generateForm({
  formOptions: ['formSlug', 'indexName'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
IndexDefinitionForm.displayName = 'IndexDefinitionForm';